module.exports = __webpack_public_path__ + "img/422.fdb276c9.png";